import { $_app_server } from '@/_helpers'

export const reestrService = {
    list,
    listLetters,
    listByDate,
    selectLetter,
    unselectLetter,
    registry,
    defaultBaseURL,
    updateReestr
}

function list () {
    return $_app_server.get("reestr").then(response => response.data)
}

function listLetters (id) {
    return $_app_server.get("reestr/" + id).then(response => response.data)
}

function listByDate (day) {
    return $_app_server.get("reestr/date/" + day).then(response => response.data)
}

function selectLetter (id) {
    return $_app_server.patch("letters/" + id + "/prereestr").then(response => response.data)
}

function unselectLetter (id) {
    return $_app_server.patch("letters/" + id + "/print").then(response => response.data)
}

function updateReestr (obj) {
    return $_app_server.post("reestr/day", obj).then(response => response.data)
}

// Отправка отсканированных писем для формирования реестра (создание реестра)
function registry (ids) {
    return $_app_server.post("reestr", ids).then(response => response.data)
}

function defaultBaseURL () {
    return $_app_server.defaults.baseURL
}



